import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { GeneralService } from './general.service';
import { PermisoService } from './permiso.service';

@Injectable()
export class AlertasService {

    constructor
        (
            private globals: Globals,
            private http: HttpInterceptor,
            private general: GeneralService,
            private permisoService: PermisoService
        ) { }

    getAlertas(): Observable<any> {
        return this.permisoService
            .getPermisoAction('VER-ALERTAS')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
                            idCliente:localStorage.getItem('idCliente')
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    alertaLeida(id: number): Observable<any> {
        return this.permisoService
            .getPermisoAction('MARCAR-ALERTA')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            id: id
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }
}